import script from "./EventPartyIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventPartyIndex.vue?vue&type=script&setup=true&lang=ts"

import "./EventPartyIndex.vue?vue&type=style&index=0&id=cf01ae04&lang=scss&scoped=true"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf01ae04"]])

export default __exports__